import { isDebug } from '@/utils';
import { pageConfig, flowTypes } from '@/common/service/page-config';

const loaderLogger = (type, preData, nextData) => {
  console.groupCollapsed('loader: ', type);
  console.log(`preData:`, preData);
  console.log(`nextData:`, nextData);
  console.groupEnd();
}

export default class PageLoader {
  // startData, preData => nextData
  startData = null;
  decorators = [];
  cartData = [];

  constructor(startData) {
    this.pageConfig = pageConfig;
    this.startData = startData;
  }
  get flowType() {
    return this.pageConfig.type || flowTypes.buyNow;
  }
  push(type, decorator, tester = () => true) {
    if (tester()) {
      this.decorate(type, decorator);
    }
  }
  decorate(type, decorator) {
    this.decorators.push({
      type,
      decorator,
    });
  }
  async dispatch() {
    let preData = this.startData;
    while(this.decorators.length) {
      const { type, decorator } = this.decorators.shift();
      const nextData = await decorator.call(this, preData);
      isDebug && loaderLogger(type, preData, nextData)
      preData = nextData;
    }
    this.cartData = preData;
    return preData;
  }
}
